// import React from 'react';
// import { Navigate } from 'react-router-dom';
// //import { useAuth } from '../components/auth/AzureAuthProvider';
// import { useAuth } from '../components/auth/SimpleAuthProvider'; // ← Change this line
// import { LoadingScreen } from '../components/feedback/LoadingScreen';

// interface ProtectedRouteProps {
//   children: React.ReactNode;
// }

// export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
//   const { isAuthenticated, isLoading } = useAuth();

//   if (isLoading) {
//     return <LoadingScreen />;
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   return <>{children}</>;
// };


import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../components/auth/SimpleAuthProvider';
import { LoadingScreen } from '../components/feedback/LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};